export const menuList = [
  {
    path: '/kpi-explorer',
    title: 'KPI Dashboard',
    iconClass: 'costIcon',
    type: 'link',
    Menusub: false,
    module: ['Cost Explorer'],
    selected: false,
  },
  {
    path: '/data-space',
    title: 'Dataspaces',
    iconClass: 'dataSetsIcon',
    type: 'link',
    Menusub: false,
    module: ['Cost Explorer'],
    selected: false,
  },
  {
    path: '/integrations',
    title: 'Integrations',
    iconClass: 'integrations',
    type: 'link',
    Menusub: false,
    module: ['System Configuration'],
    selected: false,
  },
  {
    path: '/user',
    iconClass: 'userIcon',
    title: 'Users',
    type: 'link',
    selected: false,
    module: ['Users'],
    Menusub: false,
  },
  {
    path: 'activity-logs',
    title: 'Activity Logs',
    iconClass: 'activityIcon',
    type: 'link',
    Menusub: false,
    module: ['Activity Logs'],
    selected: false,
  },
  {
    path: '/system-configuration',
    title: 'System Configuration',
    iconClass: 'subscriptionIcon',
    type: 'link',
    Menusub: false,
    module: ['System Configuration'],
    selected: false,
  },
];
